<tt-list [ttData]="accountingProcessings" [ttFilter]="searchText"></tt-list>
